export default "__VITE_ASSET__DuUNLqLv__"